import { computed, ref, set, watch } from '@vue/composition-api';
import { defineStore } from 'pinia';
import { fetchDeploymentsService } from '@/services/build-service/deploymentRequests';
import { APPLICATION_STORE, SCREEN_STORE } from '@/store/common/storeConstants';
import { getExpressionParser } from '@/lib/nuclicore-core';

export const useScreenStore = defineStore(SCREEN_STORE , () => {
    const screensMeta = ref({});

    const addScreenElementMeta = (screenId, fieldId, metaData) => {
        if (!screensMeta.value[screenId]) {
            set(screensMeta.value, screenId, {});
        }
        set(screensMeta.value[screenId], fieldId, { ...metaData });
    }

    const getScreenElementMeta = (screenId, fieldId) => screensMeta.value[screenId] ? screensMeta.value[screenId][fieldId] : null;

    return {
        screensMeta,
        addScreenElementMeta,
        getScreenElementMeta
    }
});
